module.exports = __webpack_public_path__ + "static/media/rvfctemplate.caf24392.csv";